import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

const URL_BASE = 'https://arreyimobiliaria.com.br/api'
// DESENVOLVIMENTO
//const URL_BASE = 'http://10.10.1.103:8080/SiteM1/4'

export const axiosRequest = axios.create({
    baseURL: URL_BASE,
    timeout: 30000,
    maxContentLength: 5242880,
    withCredentials: false,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
})

Vue.use(VueAxios, axiosRequest)
